import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

/**
 * Omitted from published OpenAPI (settings); see `orval.config.ts` userManagement input URL.
 * Accepts the same object shape the UI supplies via
 * `src/userManagement/application/types/UserManagementApiContracts` `UpdateTenantSettingsInput`.
 *
 * Path matches the gateway-prefixed User Management v1 routes (`/api/user-management/v1/...`).
 * Symbol naming follows Orval's V1 convention (`getApiUserManagementV1*`) so that, once the
 * BE adds these endpoints to the OpenAPI spec, the regenerated client can drop in cleanly
 * and this file can be deleted.
 */
export const getApiUserManagementV1Settings = (options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<void>({ url: '/api/user-management/v1/settings', method: 'GET', signal }, options);
};

export const putApiUserManagementV1Settings = (updateTenantSettingsInput: unknown, options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<void>(
    {
      url: '/api/user-management/v1/settings',
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTenantSettingsInput,
      signal
    },
    options
  );
};
